import { render, staticRenderFns } from "./ResendVerification.vue?vue&type=template&id=ebf6b6f6&"
import script from "./ResendVerification.vue?vue&type=script&lang=js&"
export * from "./ResendVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports